module.exports = __webpack_public_path__ + "img/banner-about.bbe00829.png";